import Marquee from "react-fast-marquee";
import { useEffect, useState } from "react";

export default function MarqueeBar() {
  const [play, setPlay] = useState(true);
  useEffect(() => {
    const m = window.matchMedia("(prefers-reduced-motion: reduce)");
    setPlay(!m.matches);
    const onChange = (e) => setPlay(!e.matches);
    m.addEventListener?.("change", onChange);
    return () => m.removeEventListener?.("change", onChange);
  }, []);

  return (
    <div
      aria-hidden="true"
      className="w-full bg-[var(--lime)] border-y border-[var(--ink)] py-4 md:py-6 overflow-hidden"
    >
      <Marquee
        gradient={false}
        speed={38}
        play={play}
        pauseOnHover={false}
        className="font-display text-4xl md:text-6xl lg:text-7xl tracking-tighter"
      >
        <span className="mx-6 md:mx-10">ΝΕΑΝΙΚΟ &amp; ΠΟΛΥΧΡΩΜΟ</span>
        <span className="mx-6 md:mx-10 text-outline">BLOUZES4ALL.GR</span>
        <span className="mx-6 md:mx-10">★ ΝΕΑ ΣΥΛΛΟΓΗ 2025</span>
        <span className="mx-6 md:mx-10">ORIGINAL × COTTON</span>
        <span className="mx-6 md:mx-10 text-outline">DROP Νο. 001</span>
        <span className="mx-6 md:mx-10">ΠΑΡΑΓΓΕΛΙΑ ΜΕΣΩ EMAIL</span>
      </Marquee>
    </div>
  );
}
